import { Component, inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ColorScheme, ColorSchemeManagerService } from '@shared/services/color-scheme-manager';

/**
 * The color scheme mini picker is a single button with a menu attached that lets you pick the color scheme without leaving the page.
 */
@Component({
  selector: 'app-color-scheme-mini-picker',
  templateUrl: './color-scheme-mini-picker.component.html',
  styleUrls: ['./color-scheme-mini-picker.component.scss'],
  standalone: false,
})
export class ColorSchemeMiniPickerComponent {
  private readonly colorSchemeManager = inject(ColorSchemeManagerService);
  private readonly fb = inject(FormBuilder);

  public readonly ColorScheme = ColorScheme;

  public readonly form = this.fb.group({
    scheme: [this.currentScheme],
  });

  public get currentScheme(): ColorScheme | null {
    return this.colorSchemeManager.getSavedScheme();
  }

  public pickScheme(scheme: ColorScheme | null): void {
    this.colorSchemeManager.setScheme(scheme);
  }
}
